























import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
import DistrictLabel from "@/modules/regions/DistrictLabel/index.vue";
import {toSlug} from "@/shared/services/helper/utils";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {DistrictStore} from "@/modules/regionsv2/district/store";

@Component({
    name: "DistrictSelectorV2",
    components: {DistrictLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';

    @Model("change", {type: Number})
    readonly districtId!: number;

    @Emit("change")
    handleChange(value?: number) {
        return value;
    }

    @Prop({required: true})
    readonly provinceId!: number;

    get districtIds() {
        return DistrictStore.mapIdsByProvinceId[this.provinceId];
    }

    get districtData() {
        return DistrictStore.data;
    }

    @Watch("provinceId", {immediate: true})
    async onChangeProvinceId(val: number, oldVal: number) {
        if (!val && !oldVal) return;
        if (!val && oldVal) {
            this.handleChange();
            return;
        }
        try {
            await DistrictStore.listDistrictsByProvinceV21(val);
            if (!this.districtId) return;
            if (this.districtIds) {
                if (this.districtIds.some((id: number) => id === this.districtId))
                    return;
                else
                    this.handleChange();
            }
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: e?.response?.data?.message || "Đã có lỗi xảy ra"
            });
        }
    }

    private filterOption(input: string, option: any) {
        return (toSlug(option.componentOptions.children[0].elm.textContent, " ")
                .toLowerCase()
                .indexOf(toSlug(input, " ").toLowerCase()) >= 0);
    }
}
